import { UserMode } from "../../lib/UserMode";

export function adultConversationUserModeForPath(
  pathname: string,
  userMode: UserMode,
) {
  return pathname.includes("/teach/conversations")
    ? UserMode.Educator
    : userMode;
}
